import { each } from 'lodash';
var PubSubManager = {
    subscribers: [],
    subscribe: function (parent, callback, eventName) {
        this.subscribers.push({ parent, callback, eventName });
    },
    openMenu: function () {
        each(this.subscribers, function (subscriber) {
            if (subscriber.eventName === 'openMenu') {
                subscriber.callback(undefined, subscriber.parent);
            }
        });
    },
};
export default PubSubManager;
